import isEmpty from 'lodash/isEmpty';
import * as yup from 'yup';

import { precisionFormat } from 'utils/number';

import { EXPERIENCE_INPUTS } from './constants';

export const assignmentValidator = {
  role: {
    validate: value => !isEmpty(value) || 'assignment.role.required'
  },
  percentage: {
    validate: value => (value >= 1 && value <= 100) || 'assignment.percentage.max'
  }
};

export const editProjectFormValidations = {
  name: {
    required: 'projectName.presence'
  },
  code: {
    required: 'projectCode.presence'
  },
  clientId: {
    required: 'customer.presence'
  },
  serviceType: {
    required: 'serviceType.presence'
  }
};

export const newProjectFormValidations = {
  ...editProjectFormValidations,
  status: {
    required: 'status.presence'
  }
};

const requiredSelect = msg =>
  yup.mixed().test('required-select', msg, v => v !== null && v !== undefined && v !== '');

export const newResourceFormValidations = yup.object({
  email: yup.string().required('email.presence').email('email.invalid'),
  location: requiredSelect('location.presence'),
  department: requiredSelect('department.presence'),
  role: requiredSelect('role.presence'),
  seniority: requiredSelect('seniority.presence'),
  capacityInHours: yup
    .number()
    .transform((v, orig) => (orig === '' ? undefined : v))
    .moreThan(0, 'resource.capacityHours.range')
    .max(7.5, 'resource.capacityHours.range'),
  experiencesSelected: yup
    .array()
    .test(
      'experiencesSelectedValidator',
      'skills.presence',
      value => !value?.some(item => !item?.skill || !item?.weeks)
    )
});

export const projectFinancialInfoValidator =
  ({ clientBudget, costsAdjustment, billedAdjustment }) =>
  values => {
    const {
      clientBudget: clientBudgetValue,
      costsAdjustment: costsAdjustmentValue,
      billedAdjustment: billedAdjustmentValue
    } = values;
    const isFieldValid = value => value && precisionFormat(value) >= 0;
    return {
      ...(!isFieldValid(clientBudgetValue) && { [clientBudget]: ['project.clientBudget.range'] }),
      ...(!isFieldValid(costsAdjustmentValue) && { [costsAdjustment]: ['project.cost.range'] }),
      ...(!isFieldValid(billedAdjustmentValue) && { [billedAdjustment]: ['project.billed.range'] })
    };
  };

export const openPeriodValidator = yup.object({
  name: yup.string().required('periodName.presence').max(40)
});

export const editResourceDetailsValidations = {
  englishLevel: {
    required: 'englishLevel.presence'
  }
};

export const softSkillValidation = {
  skill: { required: 'softSkill.presence' }
};

export const technicalSkillsValidations = {
  value: { required: 'technicalSkill.presence' },
  years: {
    max: { value: EXPERIENCE_INPUTS.years.max, message: 'years.presence' },
    min: { value: EXPERIENCE_INPUTS.years.min, message: 'years.presence' }
  },
  months: {
    max: { value: EXPERIENCE_INPUTS.months.max, message: 'months.presence' },
    min: { value: EXPERIENCE_INPUTS.months.min, message: 'months.presence' }
  }
};

export const trainingSkillValidation = {
  skill: { required: 'technicalSkill.presence' }
};
